export type AppEnvironment = 'dev' | 'test' | 'prod';

let environment: AppEnvironment | 'unknown' = 'unknown';

const isAppEnvironment = (value: unknown): value is AppEnvironment =>
  value === 'dev' || value === 'test' || value === 'prod';

export const getAppEnvironment = (): AppEnvironment | 'unknown' => environment;

export const initializeAppEnvironment = async (): Promise<void> => {
  if (__MODE__ === 'development') {
    environment = __LOCAL_APP_ENV__;
    return;
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  try {
    const response = await fetch('/runtime-config.json', {
      cache: 'no-store',
      signal: controller.signal,
    });
    if (!response.ok) return;
    const config: unknown = await response.json();
    if (config && typeof config === 'object' && 'APP_ENV' in config && isAppEnvironment(config.APP_ENV)) {
      environment = config.APP_ENV;
    }
  } catch {
    environment = 'unknown';
  } finally {
    clearTimeout(timeout);
  }
};
